import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Message from "../../../Components/Message";

const ExpensesTransactionsModal = ({
  show,
  handleClose,
  mode,
  paymentData,
  expenses,
  handleSubmit,
  modalError // New prop to receive error from parent
}) => {
  const [validationError, setValidationError] = useState(null);
  const [formData, setFormData] = useState({
    expense: "",
    amount: "",
    payment_method: "كاش",
    notes: ""
  });

  useEffect(() => {
    if (paymentData) {
      setFormData(paymentData);
    } else {
      setFormData({
        expense: "",
        amount: "",
        payment_method: "كاش",
        notes: ""
      });
    }
  }, [paymentData, show]);

  // Reset validation error when modal is opened/closed
  useEffect(() => {
    if (show) {
      setValidationError(null);
    }
  }, [show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const validateForm = () => {
    if (!formData.expense) {
      setValidationError("يرجى اختيار المصروف");
      return false;
    }
    if (!formData.amount || isNaN(formData.amount) || parseFloat(formData.amount) <= 0) {
      setValidationError("يرجى إدخال مبلغ صحيح");
      return false;
    }
    return true;
  };

  const onSubmit = () => {
    if (validateForm()) {
      handleSubmit(formData);
      setValidationError(null);
    }
  };

  // Display either API error from parent or validation error from this component
  const displayError = modalError || validationError;

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header className="modal-container flex-column-reverse" closeButton>
        <Modal.Title>
          {mode === "add" ? "إضافة مدفوعات" : "تعديل مدفوعات"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {displayError && <Message variant="danger">{displayError}</Message>}
        <Form>
          {/* Supplier Dropdown */}
          <Form.Group className="mb-3" controlId="expenseSelect">
            <Form.Label>المصروف</Form.Label>
            <Form.Select
              name="expense"
              value={formData.expense}
              onChange={handleChange}
              required
            >
              <option value="">اختر المصروف...</option>
              {expenses?.map(expense => (
                <option key={expense.id} value={expense.id}>
                  {expense.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {/* Payment Method Dropdown */}
          <Form.Group className="d-none mb-3" controlId="paymentMethod">
            <Form.Label>طريقة الدفع</Form.Label>
            <Form.Select
              name="payment_method"
              value={formData.payment_method}
              onChange={handleChange}
              required
            >
              <option value="كاش">كاش</option>
              <option value="شيك">شيك</option>
              <option value="تحويل بنكي">تحويل بنكي</option>
            </Form.Select>
          </Form.Group>

          {/* Amount Input */}
          <Form.Group className="mb-3" controlId="amount">
            <Form.Label>المبلغ</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              placeholder="0.00"
              required
              dir="ltr"
              style={{ textAlign: "right" }}
            />
          </Form.Group>

          {/* Notes Input */}
          <Form.Group className="mb-3" controlId="notes">
            <Form.Label>ملاحظات (اختياري)</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              placeholder="ملاحظات إضافية..."
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          إلغاء
        </Button>
        <Button variant="primary" onClick={onSubmit}>
          {mode === "add" ? "إضافة" : "تعديل"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ExpensesTransactionsModal;